






















































































































































































































































































































































































import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator";
import { required, max, regex, numeric } from "vee-validate/dist/rules";
import AddSetpointDialog from "./AddSetpointDialog.vue";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

import {
  ApiMessage,
  TreatmentDatabasesApi,
  PostTreatmentMasterListRequest,
  PostTreatmentDatabaseRequest,
  PutTreatmentDatabaseRequest,
  TreatmentDatabasesApiAddTreatmentDatabaseRequest,
  TreatmentDatabasesApiEditTreatmentDatabaseRequest,
  TreatmentMasterListsApi,
  SetPoint,
  LocationsApi,
  UserModel,
  GetLocationsResponse,
} from "../../../apis";
import { Dictionary } from "lodash";
import { AxiosResponse } from "axios";
import { read } from 'xlsx-with-styles';
import LocationDialog from "./LocationDialog.vue";

enum ACTION {
  NEW = "NEW",
  EDIT = "EDIT",
  VIEW = "VIEW",
}
@Component({
  components: { ValidationObserver, ValidationProvider, AddSetpointDialog, LocationDialog },
})
export default class AddTreatment extends Vue {
  currentMode: ACTION;
  selectedID: string;
  conditionNo = 1;
  registrationNum = 1;
  treatmentReq = {} as any;
  isViewMode = false;
  isEditMode = false;
  isOpenLocationDialog = false;

  isShowProductDialog = false;
  readonly NEW = ACTION.NEW;
  readonly EDIT = ACTION.EDIT;

  allLocations = [];
  locationOptions = [];
  productOptions = [];
  insectOptions = [];
  packageOptions = [];
  techniqueOptions = [];
  setPointOptions = [];
  setPointOptionsData = [];
  itemsSetPoint = [];

  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;

  created() {
    this.currentMode = this.$route.meta.mode as ACTION;
    if (this.currentMode === ACTION.EDIT || this.currentMode === ACTION.VIEW) {
      this.selectedID = this.$route.params.id;
    }
    this.isViewMode = this.currentMode === ACTION.VIEW;
    this.isEditMode = this.currentMode === ACTION.EDIT;
  }
  get formatTimeOptions() {
    return [
      { value: "MINUTES", text: this.$t("text.MINUTES") },
      { value: "HOURS", text: this.$t("text.HOURS") },
      { value: "DAYS", text: this.$t("text.DAYS") },
      { value: "WEEKS", text: this.$t("text.WEEKS") },
      { value: "MONTHS", text: this.$t("text.MONTHS") },
    ];
  }

  mounted() {
    this.initForm();
  }

  async initForm() {
    //get current mode
    const typeProduct = "product";
    const typeInsect = "insect";
    const typePackage = "package";
    const typeTechnique = "technique";
    const typeSetpoint = "setpoint";
    const isActive = (val): boolean => val.status === "Active";
    const isDefaultSetPoint = (val): boolean => val.defaultSetPoint == true;

    let res;
    try {
      this.$util.showLoading();
      [res] = await Promise.all([
        new TreatmentMasterListsApi().getTreatments(),
      ]);
    } catch (error) {
      this.$util.showError(error);
      return;
    } finally {
      this.$util.hideLoading();
    }

    this.productOptions = res.data.data.filter(
      (val) => val.treatmentType === typeProduct && isActive(val)
    );
    this.insectOptions = res.data.data.filter(
      (val) => val.treatmentType === typeInsect && isActive(val)
    );
    this.packageOptions = res.data.data.filter(
      (val) => val.treatmentType === typePackage && isActive(val)
    );
    this.techniqueOptions = res.data.data.filter(
      (val) => val.treatmentType === typeTechnique && isActive(val)
    );
    this.setPointOptions = res.data.data
      .filter(
        (val) =>
          val.treatmentType === typeSetpoint &&
          isActive(val) &&
          isDefaultSetPoint(val)
      );
    this.setPointOptionsData = res.data.data.filter(
      (val) => val.treatmentType === typeSetpoint && isActive(val)
    );
    const setPointOptionsDataAll = res.data.data.filter(
      (val) => val.treatmentType === typeSetpoint
    );

    if (
      (this.currentMode === ACTION.EDIT || this.currentMode === ACTION.VIEW) &&
      this.selectedID
    ) {
      let treatmentById;
      let locationRes;
      try {
        this.$util.showLoading();
        [treatmentById, locationRes] =
          await Promise.all([
            new TreatmentDatabasesApi().getTreatmentDatabaseById({
              id: this.selectedID,
            }),
            new LocationsApi().getLocations(),
          ]);
      } catch (error) {
        this.$util.showError(error);
        return;
      } finally {
        this.$util.hideLoading();
      }

      [this.treatmentReq] = treatmentById.data.data;
      this.treatmentReq.treatmentFormat = ("" + this.treatmentReq.treatmentFormat).toUpperCase();
      this.conditionNo = this.treatmentReq.conditionNo;
      this.registrationNum = this.treatmentReq.registrationNum;
      this.treatmentReq.product = this.productOptions.find(
        (product) => product.id === this.treatmentReq.product
      );
      this.treatmentReq.package = this.packageOptions.find(
        (pack) => pack.id === this.treatmentReq.package
      );
      this.treatmentReq.tecnique = this.productOptions.find(
        (technique) => technique.id === this.treatmentReq.technique
      );
      this.setPointOptions = [];
      this.treatmentReq.setPoint.forEach((setPoint) => {
        const setPointFound = setPointOptionsDataAll.find(
          (setPointData) => setPointData.id === setPoint.id
        );
        this.setPointOptions.push({ ...setPointFound, value: setPoint.value });
      });

      this.locationOptions = locationRes.data.data;
      const specificLocationIds = this.treatmentReq.specificLocations.map(location => location.id);
      this.treatmentReq.specificLocations = this.locationOptions.filter(location => specificLocationIds.includes(location.id)).map(location => location.id);
    } else {
      const [locationRes]=  await Promise.all([new LocationsApi().getLocations()]);
      this.locationOptions = locationRes.data.data;
      this.treatmentReq = {} as PostTreatmentDatabaseRequest;
    }
  }

  message = "";

  removeInsects(item) {
    if (this.isViewMode) return;
    const index = this.treatmentReq.insects.indexOf(item.id);
    if (index >= 0) this.treatmentReq.insects.splice(index, 1);
  }

  removeSpecificLocations(item) {
    if (this.isViewMode) return;
    this.treatmentReq.specificLocations = this.treatmentReq.specificLocations.filter(location => location !== item.id);
    this.$nextTick(() => {
      // this.onCloseLocationDialog();
      this.locationOptions = this.locationOptions;
    });
  }

  addSetpoint() {
    this.isShowProductDialog = true;
  }

  async addSetPointCompleted(setPoint) {
    let setPointSelected = this.setPointOptionsData.find(
      (point) => point.id === setPoint.id
    );
    if (!setPointSelected) {
      try {
        this.$util.showLoading();
        const res = await this.addNewSetPoint(setPoint);
        this.setPointOptionsData.push(res.data.data[0]);
        this.setPointOptions.push(res.data.data[0]);
        setPointSelected = res.data.data[0];
      } catch (error) {
        this.$util.showError(error);
      } finally {
        this.$util.hideLoading();
      }
    }
    const setPointExists = this.setPointOptions.find(
      (point) => point.id === setPointSelected.id
    );
    if (setPointExists) return;
    this.setPointOptions.push({ ...setPoint, value: "" });
  }
  selectAllLocations() {
    const selectCount = this.treatmentReq.specificLocations? this.treatmentReq.specificLocations.length:  0;
    if (selectCount === this.locationOptions.length){
      this.checkAll = true;
    }
    return (
      selectCount === this.locationOptions.length
    );
  }
  someLocations() {
    return (this.treatmentReq.specificLocations? this.treatmentReq.specificLocations.length:  0) >0;
  }
  locationsKey= 0;
  checkAll= false;
  toggle() {
    if (this.selectAllLocations()) {
      this.treatmentReq.specificLocations = [];
      this.checkAll = false;
    } else {
      const selectedAll = this.locationOptions.map(l=>l.id);
      this.treatmentReq.specificLocations = selectedAll;
      this.checkAll = true;
    }
    this.locationsKey++;
  }
  addNewSetPoint(setPointName) {
    const body = {
      treatmentName: setPointName,
      treatmentType: "setpoint",
    } as PostTreatmentMasterListRequest;

    return new TreatmentMasterListsApi().addTreatment({
      postTreatmentMasterListRequest: body,
    });
  }

  removeSetPoint(setPointRemove) {
    if (this.isViewMode) return;
    this.setPointOptions = this.setPointOptions.filter(
      (setPoint) => setPoint.id !== setPointRemove.id
    );
  }


  get saveTreatmentClick() {
    return this.$store.getters.saveTreatmentClick;
  }

  @Watch("saveTreatmentClick")
  onSaveTreatmentClick() {
    this.onSubmit();
  }

  async onSubmit() {
    const isValid = await this.observer.validate();
    if (!isValid) {
      this.$util.goToErrorField(this.observer);
      return;
    }
    this.$util.showLoading();
    await this.doSubmit()
      .then((res) => this.handleSuccess())
      .catch((err) => this.handleFailed(err));
    this.$util.hideLoading();
  }

  requestBuilder(): PostTreatmentDatabaseRequest | PutTreatmentDatabaseRequest {
    return {
      // isSpecificLocation: this.treatmentReq.isSpecificLocation,
      specificLocations: this.treatmentReq.specificLocations,
      product: this.treatmentReq.product.id
        ? this.treatmentReq.product.id
        : this.treatmentReq.product,
      isPallet: this.treatmentReq.isPallet,
      conditionNo: this.conditionNo,
      registrationNum: this.registrationNum,
      package: this.treatmentReq.package.id
        ? this.treatmentReq.package.id
        : this.treatmentReq.package,
      tecnique: this.treatmentReq.technique.id
        ? this.treatmentReq.technique.id
        : this.treatmentReq.technique,
      insects: (this.treatmentReq.insects || []).map((insects) =>
        insects.id ? insects.id : insects
      ),
      treatmentTime: this.treatmentReq.treatmentTime,
      treatmentFormat: this.treatmentReq.treatmentFormat,
      expiryTime: this.treatmentReq.expiryTime,
      expiryFormat: this.treatmentReq.expiryFormat,
      setPoint: (this.setPointOptions || []).map((setPoint) => ({
        id: setPoint.id,
        value: setPoint.value,
      })) as SetPoint[],
    } as PostTreatmentDatabaseRequest | PutTreatmentDatabaseRequest;
  }

  doSubmit(): Promise<AxiosResponse> {
    const body = this.requestBuilder();
    if (this.currentMode === ACTION.EDIT && this.selectedID) {
      return new TreatmentDatabasesApi().editTreatmentDatabase({
        id: this.selectedID,
        putTreatmentDatabaseRequest: body as PutTreatmentDatabaseRequest,
      });
    } else {
      return new TreatmentDatabasesApi().addTreatmentDatabase({
        postTreatmentDatabaseRequest: body as PostTreatmentDatabaseRequest,
      } as TreatmentDatabasesApiAddTreatmentDatabaseRequest);
    }
  }

  getRouteCancel() {
    this.$router.push("/treatments/database");
  }

  handleSuccess() {
    this.getRouteCancel();
  }

  handleFailed(err) {
    this.$util.showError(err);
  }

  get apiMessages(): Dictionary<ApiMessage[]> {
    return this.$store.getters.apiMessages;
  }

  @Watch("apiMessages", { deep: true })
  apiMessagesWatch(messages: Dictionary<ApiMessage[]>) {
    this.$util.showApiError(messages, this.observer);
  }

  onOpenLocationDialog() {
    if (this.isViewMode) return;
    this.isOpenLocationDialog = true;
  }

  onCloseLocationDialog() {
    this.isOpenLocationDialog = false;
  }

  onLocationAdd(locationSelected) {
    if (!this.treatmentReq.specificLocations || this.treatmentReq.specificLocations.length === 0) this.treatmentReq.specificLocations = [locationSelected];
    this.treatmentReq.specificLocations = Array.from(new Set(this.treatmentReq.specificLocations));
    this.locationOptions = this.treatmentReq.specificLocations;
    this.onCloseLocationDialog();
  }
}
